function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { getUrlParts } from '../../componentWrappers/SmartLink/getLinkPropsFromUrl';
import useTheme from '../../useTheme';
import Image from '../Image/Image';
var BANKSY_BASE_URL = 'https://assets.stash.com';
var BANKSY_PREFIX = 'altText';
export function translateUrlToBanjoString(srcUrl) {
  var _getUrlParts = getUrlParts(srcUrl),
      pathname = _getUrlParts.pathname;

  var paths = pathname.split('/').slice(1, -1);
  var middle = paths.slice(0, -1).join('-');
  var last = paths[paths.length - 1];
  return "".concat(BANKSY_PREFIX, "/").concat(middle, "/").concat(last);
}
export var useImageModeSupport = function useImageModeSupport(image) {
  var _useTheme = useTheme(),
      mode = _useTheme.mode;

  var _queryString$parseUrl = queryString.parseUrl(image),
      url = _queryString$parseUrl.url,
      query = _queryString$parseUrl.query;

  var fullUrl = url;

  if (url.startsWith('/') && !url.startsWith('//')) {
    fullUrl = "".concat(BANKSY_BASE_URL).concat(url);
  }

  return queryString.stringifyUrl({
    url: fullUrl,
    query: _objectSpread(_objectSpread({}, query), {}, {
      mode: mode
    })
  });
};
export var BanksyImage = function BanksyImage(props) {
  return /*#__PURE__*/React.createElement(Image, _extends({}, props, {
    src: useImageModeSupport(props.src),
    alt: props.alt
  }));
};
BanksyImage.propTypes = {
  src: PropTypes.string.isRequired
};
export default BanksyImage;